import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { KeycloakService } from './keycloak.service';

@Injectable({ providedIn: 'root' })
export class MasterAdminGuard implements CanActivate {
  constructor(private keycloak: KeycloakService, private router: Router) {}
  canActivate(): boolean | UrlTree {
    return this.keycloak.isMasterAdministrator() || this.router.parseUrl('/home');
  }
}
